import React from 'react'

import FormManager from '../../../../gd-form/common/form-manager'
import FormAddDeprecated from "../../../../gd-form/form/deprecated/form-add/form-add"
import ProjectForm_CopyOptions from "./copy-options/copy-options"
import ProjectForm_Description from "./description/description"
import ProjectForm_Planning from "./planning/planning"
import ProjectForm_NewLocation from "./new-location/new-location"
import ProjectForm_Name from "./name/name"
import {ModalCopy_CopyOption} from "../../@types"
import {Copy_Manager} from "../../model/manager"
import {CopyProject_Manager} from "../../model/copy-project-manager"
import {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import Modal_Submit from "../../../components/submit/submit"

type Props = {
    manager : Copy_Manager
}

export default function ModalCopy_Project(props: Props) {

    const manager = props.manager as CopyProject_Manager

    const rescheduleRequired: any               = []
    const copyOptions: ModalCopy_CopyOption[] = [
        {id: "tasks",           title: "Tasks"},
        {id: "subprojects",     title: "Sub folders/projects"},
        {id: "events",          title: "Events"},
        {id: "customFields",    title: "Custom fields settings"},
    ]

    if (!manager.copyAsTemplate) {
        copyOptions.push(
            {id: "users",           title: "Users and assignments"},
        )
    }

    const onSubmit = (result: any) => {
        if (result.copyOptions.includes("users")) {
            manager.validateUsers(result)
        } else {
            manager.commitCopy(result)
        }
    }

    const initFormData = {
        name            : manager.projectToCopy.name + " - copy",
        company         : manager.projectToCopy.companyId,
        parentProject   : manager.copyAsTemplate ? null : manager.projectToCopy.parentId,
        description     : "",
        prefix          : "",
        startDate       : moment(),
        endDate         : null,
        copyOptions     : ["tasks","subprojects","users","customFields","events"],
    }

    const formStructure = {
        isFormChanged   : true,
        fields          : {
            name                : {
                type        : 'select',
                isRequired  : true,
            },
            company             : {
                type        : 'select',
                isRequired  : true,
            },
            parentProject       : {
                type        : 'select',
                isRequired  : false,
            },
            description         : {
                type        : 'input',
                isRequired  : false
            },
            prefix              : {
                type        : 'select',
                isRequired  : false,
            },
            startDate           : {
                type        : 'select',
                label       : 'Start date',
                isRequired  : manager.rescheduleRequired && !manager.copyAsTemplate,
                validator   : (value: any, formManager: FormManager)=>{
                    //  && formManager.fields.endDate - because we validate startDate before init endDate
                    if (value && formManager.fields.endDate) {
                        formManager.validateField('endDate');
                    }
                    return true;
                }
            },
            endDate             : {
                type        : 'select',
                label       : 'End date',
                isRequired  : false,
                validator   : (value: any, formManager: FormManager)=>{
                    if (value) {
                        const startDate = formManager.getValue('startDate');
                        if (!startDate || !value.isAfter(startDate, 'day')) {
                            return "The end date occurs before the start date";
                        }
                    }
                    return true;
                }
            },
            copyOptions         : {
                type        : 'select',
                isRequired  : false,
            }
        },
        onSubmit        : onSubmit
    }

    const form: FormManager = new FormManager(formStructure,initFormData)

    const onParentSelected = (projectId: ID) => {
        form.setFieldValue("company", gd.companyId)
        form.setFieldValue("parentProject", projectId)
    }

    const onCopyOptionSelect = (id: ID) => {
        let newSelectedOptions = form.getValue('copyOptions')
        newSelectedOptions = gd.utils.toggleArrayValue(newSelectedOptions,id)
        form.setValue('copyOptions', newSelectedOptions)
    }

    const selectedOptions   = form.getValue('copyOptions')
    const submitLabel       = manager.copyAsTemplate ? "Save as template" : "Copy";
    const showCopyOptions   = !manager.projectToCopy.isPage && !manager.projectToCopy.isWhiteboard && !manager.projectToCopy.isLink && !manager.projectToCopy.isEmbed && !manager.projectToCopy.isTodos
    const showLocation      = !manager.copyAsTemplate
    const showDescription   = manager.copyAsTemplate

    return (
        <div className="flex-column-top-stretch flex-1 min-h-0">
            <FormAddDeprecated className  = "flex-row-left-top flex-1"
                               style      = {{height: 'calc(100% - 50px - 90px)'}}
                               form       = {form}
                               showSubmit = {false}>
                <div className="tbl">
                    <ProjectForm_Name form={form}/>

                    {showLocation &&
                        <ProjectForm_NewLocation form               = {form}
                                                 project            = {manager.projectToCopy}
                                                 onParentSelected   = {onParentSelected}/>}

                    <ProjectForm_Planning project               = {manager.projectToCopy}
                                          form                  = {form}
                                          copyAsTemplate        = {manager.copyAsTemplate}
                                          rescheduleRequired    = {rescheduleRequired}/>

                    {showDescription &&
                        <ProjectForm_Description form={form}/>}

                    {showCopyOptions &&
                        <ProjectForm_CopyOptions copyOptions        = {copyOptions}
                                                 selectedOptions    = {selectedOptions}
                                                 onCopyOptionSelect = {onCopyOptionSelect}/>}
                </div>
            </FormAddDeprecated>

            <Modal_Submit type      = {ButtonType.PRIMARY}
                          label     = {submitLabel}
                          onSubmit  = {()=>{form.onSubmitClick()}}/>
        </div>
    )
}
